import { FC } from 'react';
import { Money } from 'types';
import { CreditVoucherDisclaimer } from 'components/Disclaimers';
import VoucherExpireLineItem from './VoucherExpiryLineItem';
import PaymentsCard from '../PaymentsCard';
import LineItem from '../LineItem';
import BottomTotal from '../BottomTotal';
import { CardProps } from 'roo-ui/components';

interface CreditVoucherRefundBreakdownProps extends CardProps {
  voucherTotal: Money;
}

const creditVoucherTitle = (
  <>
    Credit voucher
    <CreditVoucherDisclaimer.Link />
  </>
);

const CreditVoucherRefundBreakdown: FC<CreditVoucherRefundBreakdownProps> = ({ voucherTotal, ...styles }) => (
  <PaymentsCard {...styles} data-testid="credit-voucher-refund-breakdown">
    <LineItem title={creditVoucherTitle} totals={[voucherTotal]} data-testid="voucher-line-item" />
    <VoucherExpireLineItem />
    <BottomTotal title="Total refund" totals={[voucherTotal]} />
  </PaymentsCard>
);

export default CreditVoucherRefundBreakdown;
